import { KeyIcon } from '@heroicons/react/24/outline'

export default function SettingsPage() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">시스템 설정</h1>
      </div>

      {/* API Keys Section */}
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex items-center gap-2 mb-4">
          <KeyIcon className="h-5 w-5 text-gray-400" />
          <h2 className="text-lg font-medium text-gray-900">API 키 관리</h2>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              관리자 등록 코드
            </label>
            <input
              type="text"
              value="ADMIN_SECRET_2024"
              readOnly
              className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-50"
            />
            <p className="text-sm text-gray-500 mt-1">새로운 관리자 계정 생성에 필요한 코드입니다.</p>
          </div>
        </div>
      </div>
    </div>
  )
}